import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-landing-footer',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './landing-footer.component.html',
    styleUrls: ['./landing-footer.component.css']
})
export class LandingFooterComponent {
    currentYear = new Date().getFullYear();

    footerSections = [
        {
            title: 'Solutions',
            links: [
                { label: 'Customer', url: '#' },
                { label: 'Industry', url: '#' }
            ]
        },
        {
            title: 'Legal',
            links: [
                { label: 'Privacy Policy', url: '#' },
                { label: 'Terms Of Use', url: '#' }
            ]
        },
        {
            title: 'Pricing',
            links: [
                { label: 'Learning Library', url: '#' },
                { label: 'About Us', url: '#' },
                { label: 'FAQ', url: '#' }
            ]
        }
    ];
}
